/* TSMN form tracking - Klaviyo Track API + GA4 conditional
 * Usage: TSMNFormTracking.init(rootEl, { form_id, form_variant, form_position, klaviyo_company_id })
 */
(function(){
  if (window.TSMNFormTracking) return;

  var KLAVIYO_REVISION = '2024-10-15';

  function getAnonId(){
    try {
      var k = 'tsmn_aid';
      var v = localStorage.getItem(k);
      if (!v) {
        v = 'tsmn-' + (Date.now().toString(36)) + '-' + Math.random().toString(36).slice(2,10);
        localStorage.setItem(k, v);
      }
      return v;
    } catch(e){ return 'tsmn-' + Date.now().toString(36); }
  }

  function sendKlaviyoEvent(companyId, metricName, props, identifiers){
    var profileAttrs = {};
    if (identifiers && identifiers.email) profileAttrs.email = identifiers.email;
    if (identifiers && identifiers.phone_number) profileAttrs.phone_number = identifiers.phone_number;
    profileAttrs.anonymous_id = getAnonId();

    var payload = {
      data: {
        type: 'event',
        attributes: {
          properties: props || {},
          metric: { data: { type: 'metric', attributes: { name: metricName } } },
          profile: { data: { type: 'profile', attributes: profileAttrs } }
        }
      }
    };

    return fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': KLAVIYO_REVISION },
      body: JSON.stringify(payload),
      keepalive: true
    }).catch(function(err){ console.warn('[tsmn-track] klaviyo event failed', metricName, err); });
  }

  function sendGAEvent(eventName, props){
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName.toLowerCase().replace(/\s+/g,'_'), props || {});
    }
  }

  function fireBoth(companyId, metricName, props, identifiers){
    sendKlaviyoEvent(companyId, metricName, props, identifiers);
    sendGAEvent(metricName, props);
  }

  function init(rootEl, opts){
    if (!rootEl || rootEl.dataset.tsmnTracked === '1') return;
    rootEl.dataset.tsmnTracked = '1';

    var props = {
      form_id: opts.form_id,
      form_variant: opts.form_variant || '',
      form_position: opts.form_position || ''
    };
    var companyId = opts.klaviyo_company_id;

    var viewedFired = false;
    var startedFired = false;

    // 1. Form Viewed via IntersectionObserver (50% threshold)
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if (!viewedFired && entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            viewedFired = true;
            fireBoth(companyId, 'Form Viewed', props);
            io.disconnect();
          }
        });
      }, { threshold: 0.5 });
      io.observe(rootEl);
    } else {
      viewedFired = true;
      fireBoth(companyId, 'Form Viewed', props);
    }

    // 2. Form Started on first focus into any input
    rootEl.addEventListener('focusin', function(e){
      if (startedFired) return;
      var tag = (e.target.tagName || '').toLowerCase();
      if (tag === 'input' || tag === 'textarea' || tag === 'select') {
        startedFired = true;
        fireBoth(companyId, 'Form Started', props);
      }
    });

    // 3. Submitted - call manually from form's submit handler
    rootEl._tsmnTrackSubmitted = function(identifiers){
      fireBoth(companyId, 'Form Submitted', props, identifiers || {});
    };
  }

  window.TSMNFormTracking = { init: init, fireBoth: fireBoth };
})();
